import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx-js-style';

@Injectable()
export class ExportCustomService {
  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';

  constructor() {}

  public exportExcelCustom(
    jsonData: any[],
    fileName: string,
    data: {
      colWidths: number[];
      isDate: boolean;
      dates?: string;
      title: string;
      column: string[];
    }
  ): void {
    let { dates, title, column, isDate, colWidths } = data;
    title = title && title.toLocaleUpperCase();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

    // Thêm tiêu đề "BÁO CÁO <Tên báo cáo>"
    XLSX.utils.sheet_add_aoa(ws, [[title]], { origin: 'A1' });

    // Thêm dòng "Từ ngày: <Từ ngày> - Đến ngày: <Đến ngày>
    // Thêm tiêu đề cột: "STT", "Nguồn", "Số lượng"
    XLSX.utils.sheet_add_aoa(ws, [column], { origin: 'A4' });

    // Thêm dữ liệu từ jsonData vào bảng
    XLSX.utils.sheet_add_json(ws, jsonData, { origin: 'A5', skipHeader: true });

    // Style cho tiêu đề báo cáo
    const titleStyle = {
      font: { bold: true, sz: 14, color: { rgb: '000000' } },
      alignment: { horizontal: 'center', vertical: 'center' },
    };

    // Style cho dòng "Từ ngày"
    if (isDate) {
      XLSX.utils.sheet_add_aoa(ws, [[dates]], { origin: 'A2' });
      const dateStyle = {
        font: { italic: true, sz: 12, color: { rgb: '000000' } },
        alignment: { horizontal: 'center', vertical: 'center' },
      };
      ws['A2'].s = dateStyle;
    }

    ws['A1'].s = titleStyle;

    // Style cho tiêu đề cột
    const headerStyle = {
      font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 12 },
      fill: { fgColor: { rgb: '1F497D' } },
      alignment: { horizontal: 'center', vertical: 'center' },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    };

    // Style cho dữ liệu
    const dataStyle = {
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
      alignment: { horizontal: 'center', vertical: 'center' },
    };

    // Áp dụng style cho tiêu đề "BÁO CÁO"

    // Áp dụng style cho tiêu đề cột
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ c: col, r: 3 });
      ws[cellAddress].s = headerStyle;
    }

    // Áp dụng style cho các hàng dữ liệu
    for (let row = 4; row <= range.e.r; row++) {
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
        ws[cellAddress].s = dataStyle;
      }
    }

    // Thiết lập độ rộng cột
    ws['!cols'] = colWidths.map(value => ({ wch: value }));

    // Gộp các ô cho tiêu đề và ngày tháng
    ws['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: range.e.c } }, // Gộp ô cho tiêu đề
      { s: { r: 1, c: 0 }, e: { r: 1, c: range.e.c } }, // Gộp ô cho ngày tháng
    ];

    // Tạo workbook và thêm worksheet
    const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };

    // Tạo buffer và lưu file
    const excelBuffer: any = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.saveExcelFile(excelBuffer, fileName);
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.fileType });
    FileSaver.saveAs(data, fileName + this.fileExtension);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/ExportCustom.service.ts